import { computed } from 'vue'

import type { ComputedRef } from 'vue'
import type { NuxtError } from '#app'

interface ErrorMeta {
  title: string
  message: string
}

interface UseErrorPageOptions {
  error: NuxtError
}

interface UseErrorPageReturn {
  refMeta: ComputedRef<ErrorMeta>
  handleClickHome: () => void
}

const errorMap: Record<number, ErrorMeta> = {
  401: {
    title: 'Unauthorized',
    message: 'You are not authorized to access this page.',
  },
  403: {
    title: 'Access denied',
    message: 'You don\'t have permission to access this page.',
  },
  404: {
    title: 'Oops.. Looks like this page doesn\'t exist',
    message: 'Accidents happen, but feel free to go back to home and explore your account.',
  },
  500: {
    title: 'Server error',
    message: 'Something went wrong on our end. Please try again later.',
  },
}

const defaultMeta: ErrorMeta = {
  title: 'Something went wrong',
  message: 'An unexpected error occurred.',
}

export const useErrorPage = ({ error }: UseErrorPageOptions): UseErrorPageReturn => {
  const refMeta = computed<ErrorMeta>(() => {
    return errorMap[error.statusCode ?? 500] ?? defaultMeta
  })

  const handleClickHome = (): void => {
    clearError({ redirect: '/' })
  }

  return {
    refMeta,
    handleClickHome,
  }
}
